import "core-js/modules/es.function.name.js";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  messageUpdateEvent: function messageUpdateEvent(state) {
    return state.message.messageUpdateEvent;
  },
  todoUpdateEvent: function todoUpdateEvent(state) {
    return state.message.todoUpdateEvent;
  },
  ruleInfo: function ruleInfo(state) {
    return state.system.ruleInfo;
  },
  menuArr: function menuArr(state) {
    return state.settings.menuArr;
  }
};
export default getters;